export function safeJsonParse(input: any): any {
  try {
    return typeof input === 'string' ? JSON.parse(input) : input;
  } catch {
    return input;
  }
}
